<template>
  <div>
    <b-alert
      v-if="reasonOrigins.length < 1"
      show
      dismissible
      fade
      class="mt-1"
      variant="warning"
    >
      <div class="alert-body">
        Debe al menos registrar una razon de origen
      </div>
    </b-alert>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="5"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>{{ $t('Lists.Show') }}</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
          />
          <label>{{ $t('Lists.Entries') }}</label>
        </b-col>
        <!-- Search -->
        <b-col
          cols="12"
          md="7"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              :placeholder="$t('Lists.Search')"
            />
            <b-button
              variant="primary"
              @click="onNewReasonOrigin"
            >
              <span class="text-nowrap">Nueva razon de origen</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-table
      ref="refReasonOriginTable"
      responsive
      :items="refetchReasonOrigin"
      :fields="reasonOriginFields"
      :sort-by.sync="sortBy"
      show-empty
      :empty-text="$t('Lists.NoMatchingRecordsFound')"
      :sort-desc.sync="isSortDirDesc"
    >
      <template
        #cell(actions)="data"
      >
        <b-dropdown
          variant="link"
          no-caret
          :right="$store.state.appConfig.isRTL"
        >
          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>
          <b-dropdown-item @click="onSelectReasonOrigin(data.item)">
            <feather-icon icon="EditIcon" />
            <span class="align-middle ml-50">{{ $t('Lists.Edit') }}</span>
          </b-dropdown-item>
          <b-dropdown-item @click="onDeleteReasonOrigin(data.item)">
            <feather-icon icon="TrashIcon" />
            <span class="align-middle ml-50">{{ $t('Lists.Delete') }}</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">{{ $t('Lists.Showing') }} {{ dataMeta.Showing }} {{ $t('Lists.To') }} {{ dataMeta.to }} {{ $t('Lists.Of') }} {{ dataMeta.of }} {{ $t('Lists.Entries') }}</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalReasonOrigins"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal
      v-if="reasonOriginSelected"
      id="modal-immediateActionRequirement"
      v-model="showReasonOriginModal"
      title="Nueva razon de origen"
      size="xl"
    >
      <validation-observer
        ref="refReasonOriginRules"
        tag="form"
      >
        <b-row>
          <!-- notes labor input -->
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group
              label="Manos de obra"
            >
              <b-form-input
                v-model="reasonOriginSelected.notasManoObra"
              />
            </b-form-group>
          </b-col>
          <!-- Materias / information input -->
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group
              label="Materiales o Informacion"
            >
              <b-form-input
                v-model="reasonOriginSelected.notasMaterialesInformacion"
              />
            </b-form-group>
          </b-col>
          <!-- Metod / Process input -->
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group
              label="Metodo(Proceso)"
            >
              <b-form-input
                v-model="reasonOriginSelected.notasMetodoProceso"
              />
            </b-form-group>
          </b-col>
          <!-- Machinery or equipment input -->
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group
              label="Maquinaria o equipos"
            >
              <b-form-input
                v-model="reasonOriginSelected.notasMaquinariaEquipos"
              />
            </b-form-group>
          </b-col>
          <!-- Metricos input -->
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group
              label="Metricos"
            >
              <b-form-input
                v-model="reasonOriginSelected.notasMetricos"
              />
            </b-form-group>
          </b-col>
          <!-- Work environment input -->
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group
              label="Medio Ambiente/Clima laboral"
            >
              <b-form-input
                v-model="reasonOriginSelected.notasMedioAmbienteClimaLaboral"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            v-if="reasonOriginSelected.requerimientoMotivoOrigenId === 0 && !savingChanges"
            variant="primary"
            class="float-right"
            @click="validationReasonOrigin(() => {
              onAddReasonOrigin()
            })"
          >
            Guardar razón origen
          </b-button>
          <b-button
            v-if="reasonOriginSelected.requerimientoMotivoOrigenId > 0 && !savingChanges"
            variant="primary"
            class="float-right"
            @click="validationReasonOrigin(() => {
              onEditReasonOrigin()
            })"
          >
            Actualizar razón origen
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  // BModal,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  // BFormInvalidFeedback,
  // BFormCheckbox,
  // BFormTextarea,
  // BImg,
  BAlert,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
// import FileUploader from '@/components/FileUploader.vue'
import { ref, watch, computed } from '@vue/composition-api'
import { ValidationObserver } from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import { required } from '@validations'
import requirementService from '@/services/requirement.service'
// import optionService from '@/services/option.service'
import i18n from '@/libs/i18n'

export default {

  components: {
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BFormGroup,
    // BModal,
    BDropdown,
    BDropdownItem,
    // BFormInvalidFeedback,
    // BFormCheckbox,
    // BFormTextarea,
    // BImg,
    BAlert,

    // FileUploader,

    vSelect,

    ValidationObserver,
    // ValidationProvider,
  },
  props: {
    requerimientoId: {
      type: Number,
      required: true,
    },
    reasonOriginCount: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    /* Refs */
    const {
      fetchReasonOrigin,
      createReasonOrigin,
      deleteReasonOrigin,
      updateReasonOrigin,
    } = requirementService()
    const refReasonOriginTable = ref(null)
    const refReasonOriginRules = ref(null)

    /* Pagination */
    const perPageOptions = [10, 25, 50, 100]
    const perPage = ref(10)
    const currentPage = ref(1)
    /* Params */
    const searchQuery = ref('')
    const sortBy = ref('requerimientoMotivoOrigenId')
    const isSortDirDesc = ref(false)
    /* Data */
    const totalReasonOrigins = ref(0)
    const reasonOrigins = ref([])

    const blankreasonOriginData = {
      requerimientoMotivoOrigenId: 0,
      requerimientoId: props.requerimientoId,
      numero: '1',
      notasManoObra: '',
      notasMaterialesInformacion: '',
      notasMetodoProceso: '',
      notasMaquinariaEquipos: '',
      notasMetricos: '',
      notasMedioAmbienteClimaLaboral: '',
    }

    const reasonOriginSelected = ref(JSON.parse(JSON.stringify(blankreasonOriginData)))
    const reasonOriginFields = [
      {
        key: 'numero',
        label: 'Numero',
        sortable: false,
      },
      {
        key: 'notasManoObra',
        label: 'Mano de obra',
        sortable: false,
      },
      {
        key: 'notasMaterialesInformacion',
        label: 'Materiales o  informacion',
        sortable: false,
      },
      {
        key: 'notasMetodoProceso',
        label: 'Metodo (proceso)',
        sortable: false,
      },
      {
        key: 'notasMaquinariaEquipos',
        label: 'Maquinaria o equipos',
        sortable: false,
      },
      {
        key: 'notasMetricos',
        label: 'Metricos',
        sortable: false,
      },
      {
        key: 'notasMedioAmbienteClimaLaboral',
        label: 'Medio Ambiente / Clima laboral',
        sortable: false,
      },
      {
        key: 'actions',
        label: i18n.t('Lists.Actions'),
        sortable: false,
      },
    ]
    const refetchReasonOrigin = (ctx, callback) => {
      fetchReasonOrigin(props.requerimientoId, {
        searchQuery: searchQuery.value,
        limit: perPage.value,
        offSet: currentPage.value === 1 ? 0 : (currentPage.value * perPage.value) - perPage.value,
        sort: `${sortBy.value} ${isSortDirDesc.value ? 'ASC' : 'DESC'}`,
      }, data => {
        reasonOrigins.value = data.motivosOrigen
        totalReasonOrigins.value = data.total
        emit('update:reasonOriginCount', totalReasonOrigins.value)
        callback(reasonOrigins.value)
      })
    }

    const dataMeta = computed(() => {
      const localItemsCount = refReasonOriginTable.value ? refReasonOriginTable.value.localItems.length : 0
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalReasonOrigins.value,
      }
    })

    const refreshData = () => {
      refReasonOriginTable.value.refresh()
    }
    watch([currentPage, perPage, searchQuery], () => {
      refreshData()
    })

    /* UI */
    const showReasonOriginModal = ref(false)
    const savingChanges = ref(false)

    const onNewReasonOrigin = () => {
      reasonOriginSelected.value = JSON.parse(JSON.stringify(blankreasonOriginData))
      showReasonOriginModal.value = true
    }
    const onAddReasonOrigin = () => {
      savingChanges.value = true
      createReasonOrigin(reasonOriginSelected.value, data => {
        reasonOriginSelected.value = data
        showReasonOriginModal.value = false
        savingChanges.value = false
        refreshData()
      })
    }
    const onSelectReasonOrigin = item => {
      reasonOriginSelected.value = item
      showReasonOriginModal.value = true
    }

    const onEditReasonOrigin = () => {
      savingChanges.value = true
      updateReasonOrigin(reasonOriginSelected.value)
        .then(() => {
          showReasonOriginModal.value = false
          savingChanges.value = false
        })
    }
    const onDeleteReasonOrigin = item => {
      deleteReasonOrigin(item.requerimientoMotivoOrigenId, () => {
        refreshData()
      })
    }
    const {
      getValidationState,
    } = formValidation()

    const validationReasonOrigin = callback => {
      refReasonOriginRules.value.validate().then(success => {
        if (success) {
          callback()
        }
      })
    }
    return {
      refReasonOriginTable,
      refReasonOriginRules,

      perPageOptions,
      perPage,
      currentPage,
      searchQuery,
      sortBy,
      isSortDirDesc,
      reasonOriginSelected,
      reasonOriginFields,
      reasonOrigins,
      totalReasonOrigins,

      dataMeta,

      refetchReasonOrigin,

      required,
      getValidationState,

      showReasonOriginModal,

      savingChanges,

      onNewReasonOrigin,
      onAddReasonOrigin,
      onSelectReasonOrigin,
      onEditReasonOrigin,
      onDeleteReasonOrigin,
      validationReasonOrigin,
    }
  },
}
</script>

<style>

</style>
